var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPlugin = function SvgMapPlugin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.42.825V9.79l-3.144 1.504L4.582 9.73a1 1 0 0 0-.809.013L.578 11.219V2.215L4.184.55l.21-.454-.21.454 3.672 1.695a1 1 0 0 0 .882-.022zm0 0h.5-.5l-.23-.443zM4.188.258v9.698M8.277 2.254v9"
  }))));
};
export default SvgMapPlugin;